import React from 'react';
import { AddToShoppingList as AddToShoppingListCommon } from 'pages/common/components/AddToShoppingList';
import { useToggleSavedProjectStatus } from './hooks/use-toggle-saved-project-status';

export const AddToShoppingList = () => {
  const { isProjectSaved, saveProject, unsaveProject } = useToggleSavedProjectStatus();

  return (
    <AddToShoppingListCommon
      isProjectSaved={isProjectSaved}
      saveProjectToShoppingList={saveProject}
      removeProjectFromShoppingList={unsaveProject}
    />
  );
};
